import React from "react";
import { Formik, Form } from "formik";
import {
  Autocomplete,
  Box,
  Button,
  DialogActions,
  TextField,
} from "@mui/material";
import { useDivisionForm } from "../hooks/useDivisionForm";

function DivisionForm({ editMode, currentDivision, setOpen, handleClose }) {
  const {
    validationSchema,
    initialValues,
    handleSubmit,
    locationSearchResults,
    setSearchLocationTerm,
  } = useDivisionForm({
    editMode,
    currentDivision,
    setOpen,
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({
        isSubmitting,
        getFieldProps,
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Box sx={{ p: 3 }}>
            <TextField
              fullWidth
              id="name"
              name="name"
              label="Subject Name"
              variant="outlined"
              margin="normal"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              {...getFieldProps("name")}
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
            />
            <Autocomplete
              multiple
              options={locationSearchResults}
              getOptionLabel={(option) =>
                option?.name || "No location assigned"
              }
              noOptionsText="No locations found"
              value={values.locations || []}
              isOptionEqualToValue={(option, value) => option._id === value._id} // Ensure proper comparison
              onInputChange={(event, newInputValue) => {
                setSearchLocationTerm(newInputValue);
              }}
              onChange={(event, newValue) => {
                setFieldValue("locations", newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Locations"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  error={touched.locations && Boolean(errors.locations)}
                  helperText={touched.locations && errors.locations}
                />
              )}
            />

            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button type="submit" color="primary" disabled={isSubmitting}>
                {editMode ? "Update" : "Save"}
              </Button>
            </DialogActions>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

export default DivisionForm;
